import React, { useState } from "react";
import { Modal, Form } from "antd";
import { STATUS } from "@/utils/enum";
import CancelShipmentForm from "@/components/CancelShipmentForm/CancelShipmentForm";

const CancelShipmentModal = ({ visible, onClose, afterSubmit, shipmentId, shipmentStatus, isCancelAndRepost }) => {
  const [status, setStatus] = useState(STATUS.IDLE);
  const [formRef] = Form.useForm();

  return (
    <Modal
      title="Cancel Shipment"
      open={visible}
      onOk={formRef.submit}
      onCancel={onClose}
      confirmLoading={STATUS.LOADING === status}
    >
      <CancelShipmentForm
        formRef={formRef}
        shipmentId={shipmentId}
        afterSubmit={afterSubmit}
        setStatus={setStatus}
        shipmentStatus={shipmentStatus}
        isCancelAndRepost={isCancelAndRepost}
      />
    </Modal>
  );
};

export default CancelShipmentModal;
